import React, { useState, useEffect } from 'react';
import SupplyChainContract from '../../contracts/SupplyChainContract'; 
import tickImage from '../../img/tick.png'
import crossImage from '../../img/cross.png';

const RetailerPage = () => {
  const [batchIdForUpdate, setBatchIdForUpdate] = useState('');
  const [searchedBatchId, setSearchedBatchId] = useState('');
  const [retailerVCs, setRetailerVCs] = useState([]);
  const [searchedRetailerVC, setSearchedRetailerVC] = useState(null);
  const [updateStockingInfo, setUpdateStockingInfo] = useState('');
  const [searchInputRetailer, setSearchInputRetailer] = useState('');
  const [batchData, setBatchData] = useState(null);
  const [farmerVCData, setFarmerVCData] = useState(null);
  const [inspectorVCData, setInspectorVCData] = useState(null);
  const [distributorVCData, setDistributorVCData] = useState(null);
  const [farmerVCs, setFarmerVCs] = useState([]);
  const [inspectorVCs, setInspectorVCs] = useState([]);
  const [distributorVCs, setDistributorVCs] = useState([]);

  useEffect(() => {
    handleFetchAllRetailerVCs();
  }, []);

  
  const handleUpdateRetailerVC = async () => {
    try {
      const batchId = parseInt(batchIdForUpdate);

      if (isNaN(batchId)) {
        console.error('Invalid BatchID. Please enter a valid number.');
        return;
      }

      await SupplyChainContract.methods
        .updateRetailerVC(batchId, updateStockingInfo)
        .send({ from: window.ethereum.selectedAddress }); 

      alert('RetailerVC updated successfully!');

      handleFetchAllRetailerVCs();
      
      handleFetchFarmerVCData(batchId);
      handleFetchInspectorVCData(batchId);
      handleFetchDistributorVCData(batchId);
    } catch (error) {
      console.error('Error updating RetailerVC:', error);
    }
  };

  
  const handleFetchAllRetailerVCs = async () => {
    try {
      const totalRetailerVCs = await SupplyChainContract.methods.getTotalRetailerVCs().call();
  
      const retailerVCList = [];
      const farmerVCList = [];
      const inspectorVCList = [];
      const distributorVCList = [];
  
      for (let i = 1; i <= totalRetailerVCs; i++) {
        const retailerVC = await SupplyChainContract.methods.getRetailerVCByBatchId(i).call();
        const farmerVC = await SupplyChainContract.methods.getFarmerVCByBatchId(i).call();
        const inspectorVC = await SupplyChainContract.methods.getInspectorVCByBatchId(i).call();
        const distributorVC = await SupplyChainContract.methods.getDistributorVCByBatchId(i).call();
  
        retailerVCList.push(retailerVC);
        farmerVCList.push(farmerVC);
        inspectorVCList.push(inspectorVC);
        distributorVCList.push(distributorVC);
      }
  
      const filteredRetailerVCList = retailerVCList.filter((retailerVC) => parseInt(retailerVC[0], 10) !== 0);
  
      setRetailerVCs(filteredRetailerVCList);
      setFarmerVCs(farmerVCList);
      setInspectorVCs(inspectorVCList);
      setDistributorVCs(distributorVCList);
    } catch (error) {
      console.error('Error fetching all data:', error);
    }
  };
  

  const handleSearchByBatchIdRetailer = async () => {
    try {
      const batchId = parseInt(searchedBatchId);

      if (isNaN(batchId)) {
        console.error('Invalid BatchID. Please enter a valid number.');
        return;
      }

      const retailerVC = await SupplyChainContract.methods.getRetailerVCByBatchId(batchId).call();

      if (retailerVC.batchID !== 0) {
        setSearchedRetailerVC(retailerVC);
      } else {
        setSearchedRetailerVC(null);
        console.log('No RetailerVC found with the specified BatchID.');
      }
    } catch (error) {
      console.error('Error fetching RetailerVC:', error);
    }
  };

    const handleFetchFarmerVCData = async (batchId) => {
      try {
        const farmerVC = await SupplyChainContract.methods.getFarmerVCByBatchId(batchId).call();
        setFarmerVCData(farmerVC);
      } catch (error) {
        console.error('Error fetching FarmerVC data:', error);
      }
    };
  
    const handleFetchInspectorVCData = async (batchId) => {
      try {
        const inspectorVC = await SupplyChainContract.methods.getInspectorVCByBatchId(batchId).call();
        setInspectorVCData(inspectorVC);
      } catch (error) {
        console.error('Error fetching InspectorVC data:', error);
      }
    };
  
    const handleFetchDistributorVCData = async (batchId) => {
      try {
        const distributorVC = await SupplyChainContract.methods.getDistributorVCByBatchId(batchId).call();
        setDistributorVCData(distributorVC);
      } catch (error) {
        console.error('Error fetching DistributorVC data:', error);
      }
    };

  const convertEpochToTime = (epochTime) => {
    const date = new Date(epochTime * 1000); 
    return date.toLocaleString(); 
  };

  const handleBatchIdChange = async (batchId) => {
    try {
      const retailerVC = await SupplyChainContract.methods.getRetailerVCByBatchId(batchId).call();
  
      const farmerVC = await SupplyChainContract.methods.getFarmerVCByBatchId(batchId).call();
  
      const inspectorVC = await SupplyChainContract.methods.getInspectorVCByBatchId(batchId).call();
  
      const distributorVC = await SupplyChainContract.methods.getDistributorVCByBatchId(batchId).call();
  
      setBatchData(retailerVC);
      setFarmerVCData(farmerVC);
      setInspectorVCData(inspectorVC);
      setDistributorVCData(distributorVC);
      setBatchIdForUpdate(batchId);
  
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  return (
    <div className="container mx-auto p-8 pt-16">

    {/* Update RetailerVC Form */}
    <div className="flex justify-between">
      <div className="w-1/2 pr-4 mb-8">
      <h3 className="text-2xl font-semibold mb-4">Update Retailer Verifiable Credential</h3>
      <div className="flex items-center mb-4">
        <label className="mr-4">Batch ID:</label>
        <input
          type="text"
          value={batchIdForUpdate}
          onChange={(e) => handleBatchIdChange(e.target.value)}
          className="border p-2"
        />
      </div>
      <div className="flex items-center mb-4">
        <label className="mr-4">Stocking Info:</label>
        <input
          type="text"
          value={updateStockingInfo}
          onChange={(e) => setUpdateStockingInfo(e.target.value)}
          className="border p-2"
        />
      </div>

      {/* Check DistributorVC acceptance */}
      {distributorVCData && distributorVCData.acceptance === false && (
        <p className="text-red-500">Danger: Distributor has rejected acceptance. Batch ID is canceled.</p>
      )}

      {/* Only allow update if DistributorVC acceptance is true */}
      {distributorVCData && distributorVCData.acceptance && (
        <button onClick={handleUpdateRetailerVC} className="bg-blue-500 text-white px-4 py-2 rounded">
          Update RetailerVC
        </button>
      )}
    </div>

      {/* Display relevant data when batch ID is entered */}
      {batchData && (
        <div className="w-1/2 pl-4">
          
          {/* Display data from FarmerVC with BatchID */}
          {farmerVCData && (
            <div className="border p-2 rounded-md mb-4">
              <h5 className="text-lg font-semibold mb-2">Meat Processor VC Data | BatchID {batchIdForUpdate}</h5>
              <div className="flex justify-between">
                <div className="text-left">
                  <p>Quantity:</p>
                  <p>Grading Results:</p>
                  <p>Country of Origin:</p>
                  <p>Date of Production:</p>
                  <p>Expiry Date:</p>
                </div>
                <div className="text-right">
                  <p>{farmerVCData.quantity}</p>
                  <p>{farmerVCData.gradingResults}</p>
                  <p>{farmerVCData.countryOfOrigin}</p>
                  <p>{convertEpochToTime(farmerVCData.dateOfProduction)}</p>
                  <p>{convertEpochToTime(farmerVCData.expiryDate)}</p>
                </div>
              </div>
            </div>
          )}

          {/* Display data from InspectorVC */}
          {inspectorVCData && (
            <div className="border p-2 rounded-md mb-4">
              <h5 className="text-lg font-semibold mb-2">Inspector VC Data</h5>
              <div className="flex justify-between">
                <div className="text-left">
                  <p>Inspector Check:</p>
                  <p>Danger Check:</p>
                  <p>Remark:</p>
                  <p>Update Timestamp:</p>
                </div>
                <div className="text-right">
                  <p>
                    {inspectorVCData.inspectorCheck ? (
                      <img src={tickImage} alt="tick" style={{ width: '24px', height: '24px' }} />
                    ) : (
                      <img src={crossImage} alt="cross" style={{ width: '24px', height: '24px' }} />
                    )}
                  </p>
                  <p>
                    {inspectorVCData.dangerCheck ? (
                      <img src={tickImage} alt="tick" style={{ width: '24px', height: '24px' }} />
                    ) : (
                      <img src={crossImage} alt="cross" style={{ width: '24px', height: '24px' }} />
                    )}
                  </p>
                  <p>{inspectorVCData.remark || 'No Remark'}</p>
                  <p>{convertEpochToTime(inspectorVCData.timestamp)}</p>
                </div>
              </div>
            </div>
          )}

          {/* Display data from DistributorVC */}
          {distributorVCData && (
            <div className="border p-2 rounded-md mb-4">
              <h5 className="text-lg font-semibold mb-2">Distributor VC Data</h5>
              <div className="flex justify-between">
                <div className="text-left">
                  <p>Acceptance:</p>
                  <p>Remark:</p>
                  <p>Update Timestamp:</p>
                </div>
                <div className="text-right">
                  <p>
                    {distributorVCData.acceptance ? (
                      <img src={tickImage} alt="tick" style={{ width: '24px', height: '24px' }} />
                    ) : (
                      <img src={crossImage} alt="cross" style={{ width: '24px', height: '24px' }} />
                    )}
                  </p>
                  <p>{distributorVCData.remark || 'No Remark'}</p>
                  <p>{convertEpochToTime(distributorVCData.timestamp)}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>

      <h3 className="text-2xl font-semibold mb-4">Search Retailer VC</h3>
      {/* Search by BatchID Form */}
      <div className="mb-8 flex items-center"> 
        <div className="mr-4 flex items-center"> 
          <label className="mr-4">BatchID:</label>
          <input
            type="text"
            value={searchedBatchId}
            onChange={(e) => setSearchedBatchId(e.target.value)}
            className="border p-2"
          />
        </div>
        <button onClick={handleSearchByBatchIdRetailer} className="bg-blue-500 text-white px-4 py-2 rounded">Search</button>
      </div>


      {/* Display searched RetailerVC data */}
      {searchedRetailerVC && (
        <div className="mb-8">
          <h3 className="text-2xl font-semibold mb-4">Search Result</h3>
          <p>BatchID: {searchedRetailerVC.batchID}</p>
          <p>Stocking Info: {searchedRetailerVC.stockingInfo}</p>
          <p>Timestamp: {convertEpochToTime(searchedRetailerVC.timestamp)}</p>
        </div>
      )}

        <div className="container mx-auto">
          {/* Display all Data in a combined table */}
          <div className="mt-8">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-2xl font-semibold">Verifiable Credentials List</h3>

              {/* Search input for RetailerVCs (placed on the right) */}
              <div className="flex items-center">
                <label className="mr-4 text-lg">Search:</label>
                <input
                  type="text"
                  value={searchInputRetailer}
                  onChange={(e) => setSearchInputRetailer(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleSearchByBatchIdRetailer();
                    }
                  }}
                  className="border p-2"
                />
              </div>
            </div>

            <table className="w-full border">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-2 text-center" rowSpan="2">
                    BatchID
                  </th>
                  <th className="border p-2 text-center" colSpan="5" style={{ backgroundColor: '#6EE7B7' }}>
                    Meat Processor
                  </th>
                  <th className="border p-2 text-center" colSpan="4" style={{ backgroundColor: '#63B3ED' }}>
                    Inspector
                  </th>
                  <th className="border p-2 text-center" colSpan="3" style={{ backgroundColor: '#FFD700' }}>
                    Distributor
                  </th>
                  <th className="border p-2 text-center" colSpan="3" style={{ backgroundColor: '#FFA07A' }}>
                    Retailer
                  </th>
                </tr>
                <tr className="bg-gray-200">
                  {/* Headers for FarmerVC */}
                  <th className="border p-2 text-center bg-green-200">Quantity</th>
                  <th className="border p-2 text-center bg-green-200">Grading Results</th>
                  <th className="border p-2 text-center bg-green-200">Country of Origin</th>
                  <th className="border p-2 text-center bg-green-200">Date of Production</th>
                  <th className="border p-2 text-center bg-green-200">Expiry Date</th>
                  {/* Headers for InspectorVC */}
                  <th className="border p-2 text-center bg-blue-200">Inspector Check</th>
                  <th className="border p-2 text-center bg-blue-200">Danger Check</th>
                  <th className="border p-2 text-center bg-blue-200">Remark</th>
                  <th className="border p-2 text-center bg-blue-200">Update Timestamp</th>
                  {/* Headers for DistributorVC */}
                  <th className="border p-2 text-center bg-yellow-200">Acceptance</th>
                  <th className="border p-2 text-center bg-yellow-200">Remark</th>
                  <th className="border p-2 text-center bg-yellow-200">Update Timestamp</th>
                  {/* Headers for RetailerVC */}
                  <th className="border p-2 text-center bg-orange-200">Stocking Info</th>
                  <th className="border p-2 text-center bg-orange-200">Update Timestamp</th>
                </tr>
              </thead>
              <tbody>
                {retailerVCs
                  .filter((retailerVC) =>
                    String(retailerVC.batchID).toLowerCase().includes(searchInputRetailer.toLowerCase()) ||
                    String(retailerVC.stockingInfo).toLowerCase().includes(searchInputRetailer.toLowerCase())
                  )
                  .map((retailerVC, index) => (
                    <tr key={`retailerVC_${index}_${retailerVC.batchID}`} className={retailerVC.batchID % 2 === 0 ? 'bg-gray-100' : ''}>
                      <td className="border p-2 text-center">{retailerVC.batchID}</td>
                      {/* FarmerVC Data */}
                      <td className={`border p-2 text-center bg-green-200`}>{farmerVCs[index] ? farmerVCs[index].quantity : '-'}</td>
                      <td className={`border p-2 text-center bg-green-200`}>{farmerVCs[index] ? farmerVCs[index].gradingResults : '-'}</td>
                      <td className={`border p-2 text-center bg-green-200`}>{farmerVCs[index] ? farmerVCs[index].countryOfOrigin : '-'}</td>
                      <td className={`border p-2 text-center bg-green-200`}>
                        {farmerVCs[index] ? convertEpochToTime(farmerVCs[index].dateOfProduction) : '-'}
                      </td>
                      <td className={`border p-2 text-center bg-green-200`}>
                        {farmerVCs[index] ? convertEpochToTime(farmerVCs[index].expiryDate) : '-'}
                      </td>
                      {/* InspectorVC Data */}
                      <td className={`border p-2 text-center bg-blue-200 ${inspectorVCs[index]?.inspectorCheck === false ? 'bg-red-200' : ''}`}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          {inspectorVCs[index]?.inspectorCheck ? (
                            <img src={tickImage} alt="tick" style={{ width: '20px', height: '20px' }} />
                          ) : (
                            <img src={crossImage} alt="cross" style={{ width: '20px', height: '20px' }} />
                          )}
                        </div>
                      </td>
                      <td className={`border p-2 text-center bg-blue-200 ${inspectorVCs[index]?.dangerCheck === false ? 'bg-red-200' : ''}`}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          {inspectorVCs[index]?.dangerCheck ? (
                            <img src={tickImage} alt="tick" style={{ width: '20px', height: '20px' }} />
                          ) : (
                            <img src={crossImage} alt="cross" style={{ width: '20px', height: '20px' }} />
                          )}
                        </div>
                      </td>
                      <td className={`border p-2 text-center bg-blue-200`}>{inspectorVCs[index]?.remark}</td>
                      <td className={`border p-2 text-center bg-blue-200`}>{convertEpochToTime(inspectorVCs[index]?.timestamp)}</td>

                      {/* DistributorVC Data */}
                      <td className={`border p-2 text-center bg-yellow-200`}>{distributorVCs[index]?.acceptance ? 'Yes' : 'No'}</td>
                      <td className={`border p-2 text-center bg-yellow-200`}>{distributorVCs[index]?.remark}</td>
                      <td className={`border p-2 text-center bg-yellow-200`}>{convertEpochToTime(distributorVCs[index]?.timestamp)}</td>

                      {/* RetailerVC Data */}
                      <td className={`border p-2 text-center bg-orange-200`}>{retailerVC.stockingInfo}</td>
                      <td className={`border p-2 text-center bg-orange-200`}>{convertEpochToTime(retailerVC.timestamp)}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>


    </div>
  );
};

export default RetailerPage;
